import React, { Component, Fragment } from "react";
import { InputNumber, Radio } from "antd";
import {
	ProductTitle,
	QuestionProductLabel,
	ProductContainer,
} from "./../../../../StyledComponents";

const Inline = props => {
	const { categories, kpis, ltN, lN, sN, setResponse, statement } = props;

	const handleChangeAnswer = (value, ltN, lN, sN, k, p) => {
		setResponse(value, ltN, lN, sN, k, p);
	};

	const isKpiDisplayable = (kpis, p, currentKpi) => {
		let isFacing = false;
		let facingValue = 0;
		for (let i = 0; i < kpis.length; i++) {
			const kpi = kpis[i];
			if (kpi.id === 1 && kpi.response && kpi.response[p]) {
				facingValue = parseInt(kpi.response[p]);
				isFacing = true;
			}
		}

		//pos
		if (currentKpi.id === 14 || currentKpi.id === 15) {
			return isFacing && facingValue > 0;
		}

		//price & linear
		if (currentKpi.id === 16 || currentKpi.id === 17) {
			return isFacing && facingValue > 0;
		}
		return true;
	};

	const buildProductsView = () => {
		//const products= [];
		return (
			<div className="p-survey-simulation-phone-matrix">
				{categories.map((category, c) => {
					return (
						<Fragment key={c}>
							{category.families.map((family, c) => {
								return (
									<Fragment key={c}>
										{family.brands.map((brand, c) => {
											return (
												<Fragment key={c}>
													{brand.products.map((product, p) => {
														return (
															<ProductContainer key={p}>
																<ProductTitle className="pLabel">
																	{product.label}
																</ProductTitle>
																{kpis.map((kpi, k) => {
																	return new Boolean(kpi.survey_display) &&
																		isKpiDisplayable(
																			statement.kpis,
																			product.ean,
																			kpi
																		) ? (
																		<div className="kpi" key={k}>
																			<QuestionProductLabel>
																				{kpi.question}
																			</QuestionProductLabel>
																			{(function() {
																				switch (kpi.format) {
																					case "Num":
																						return (
																							<InputNumber
																								key={`${product.ean}${k}`}
																								value={
																									statement.kpis[k].response
																										? statement.kpis[k]
																												.response[product.ean]
																										: ""
																								}
																								onChange={value =>
																									handleChangeAnswer(
																										parseInt(value),
																										ltN,
																										lN,
																										sN,
																										k,
																										product.ean
																									)
																								}
																								style={{ width: "90%" }}
																								min="0"
																							/>
																						);
																					case "Boolean":
																						return (
																							<Radio.Group
																								value={
																									statement.kpis[k].response &&
																									statement.kpis[k].response[
																										product.ean
																									]
																										? true
																										: false
																								}
																								buttonStyle="solid"
																								onChange={e =>
																									handleChangeAnswer(
																										e.target.value,
																										ltN,
																										lN,
																										sN,
																										k,
																										product.ean
																									)
																								}
																							>
																								<Radio.Button
																									id={`${p}${k}1`}
																									value={true}
																									name="booltrue"
																								>
																									Oui
																								</Radio.Button>
																								<Radio.Button
																									id={`${p}${k}0`}
																									value={false}
																									name="boolfalse"
																								>
																									Non
																								</Radio.Button>
																							</Radio.Group>
																						);
																					default:
																						return null;
																				}
																			})()}
																		</div>
																	) : null;
																})}
															</ProductContainer>
														);
													})}
												</Fragment>
											);
										})}
									</Fragment>
								);
							})}
						</Fragment>
					);
				})}
			</div>
		);
	};
	return <Fragment>{buildProductsView()}</Fragment>;
};

export default Inline;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/Inline/Inline.js